import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "school",
    name: "school",
    component: () => import("./pages/SchoolSettings.vue"),
    meta: { title: "menu.school", requiresAuth: true, requiresStaff: true },
  },
];
